<template>
  <div>
    <b-modal
      v-model="removalAcceptance"
      :cancel-title="$t('general.no')"
      :ok-title="$t('general.yes')"
      centered
      size="sm"
      @cancel="removalAcceptance = false"
      @ok="deletionConfirmed"
    >
      <p>
        {{
          $t("toastification.areYouSureOfDeletion", {
            item: itemToDelete ? itemToDelete.title : "",
          })
        }}
      </p>
    </b-modal>
    <vue-good-table
      :class="children.length < 2 ? 'permission-table--child-no-border' : ''"
      :columns="childColumns"
      :rows="children"
      class="permission-table--child"
      styleClass="vgt-table"
    >
      <template slot="table-column" slot-scope="props">
        <!--               <span v-if="props.column.label === 'hide'" class="text-nowrap">-->
        <!--            </span>-->
      </template>
      <!--               <template slot="table-row" slot-scope="props">-->
      <!--                 <span class="text-nowrap">-->
      <!--                   {{ props.row.title }}-->
      <!--                 </span>-->

      <!--              </template>-->
      <template slot="table-row" slot-scope="props">
        <!-- Column: Name -->
        <span v-if="props.column.field === 'title'" class="text-nowrap d-flex">
          <b-form-checkbox
            v-if="$route.name !== 'managePermissions'"
            :id="`checkbox-${props.row.key}`"
            :value="props.row"
            @change="permissionChecked($event, props.row)"
          >
          </b-form-checkbox>
          <span class="row-style">
            <div style="width:250px">
              {{ props.row.title }}
            </div>
           <div>
            <feather-icon
              class="feacher-icon ml-1"
              v-if="$route.name == 'managePermissions'"
              size="16"
              icon="Edit2Icon"
              @click="editAPermission(props.row)"
            />
            <feather-icon
              class="icon-feacher ml-1"
              v-if="$route.name == 'managePermissions' && !props.row.children.length"
              size="16"
              icon="TrashIcon"
              @click="deleteAPermission(props.row)"
            />
           </div>
          </span>
          <!-- <div style="width: 100%; display:flex;align-items: center;justify-content: end">
          <feather-icon v-if="$route.name == 'managePermissions'"  style="cursor: pointer; color:#00cfe8"  class="ml-1" size="16" icon="Edit2Icon" @click="editAPermission(props.row)"/>
          <feather-icon v-if="$route.name == 'managePermissions' && !props.row.children.length" style="cursor: pointer; color: #ea5455" size="16" class="ml-1 " icon="TrashIcon" @click="deleteAPermission(props.row)"/>
</div> -->
        </span>

        <span v-if="props.column.field === 'child'" class="text-nowrap">
          <nested-table
            v-if="props.row.children.length"
            ref="nestedTable"
            :childColumns="childColumns"
            :children="props.row.children"
          ></nested-table>

          <!--                   <vue-good-table-->
          <!--                       v-if="children"-->
          <!--                       :columns="childColumns"-->
          <!--                       :rows="props.row.children"-->
          <!--                       class="permission-table&#45;&#45;child"-->
          <!--                   >-->
          <!--                <template slot="table-column" slot-scope="props">-->
          <!--               <span v-if="props.column.label === 'hide'" class="text-nowrap">-->

          <!--            </span>-->
          <!--                </template>-->
          <!--                <template slot="table-row" slot-scope="props">-->
          <!--        &lt;!&ndash; Column: Name &ndash;&gt;-->
          <!--        <span v-if="props.column.field === 'title'" class="text-nowrap">-->
          <!--         {{ props.row.title }}-->
          <!--        </span>-->
          <!--          <span v-if="props.column.field === 'child'" class="text-nowrap">-->
          <!--<nested-table v-if="props.row.children.length" :childColumns="childColumns" :children="props.row.children"></nested-table>-->
          <!--          </span>-->
          <!--                </template>-->
          <!--            </vue-good-table>-->
        </span>
      </template>
      <div slot="emptystate"></div>
    </vue-good-table>
  </div>
</template>

<script>
import { VueGoodTable } from "vue-good-table";
import { BFormCheckbox } from "bootstrap-vue";

export default {
  name: "NestedTable",
  data: () => ({
    itemToDelete: null,
    removalAcceptance: false,
  }),
  props: {
    children: {
      default: null,
    },
    childColumns: {
      default: null,
    },
  },
  components: {
    VueGoodTable,
    BFormCheckbox,
  },
  computed: {
    selectedUserPermissions: {
      get() {
        return this.$store.getters["permissions/selectedUserPermissions"];
      },
      set(permissions) {
        this.$store.commit("permissions/SET_SELECTED_USER_PERMISSIONS", permissions);
      },
    },
    formattedPermissions: {
      get() {
        return this.$store.getters["permissions/formattedPermissions"];
      },
      set(permissions) {
        this.$store.commit("permissions/SET_FORMATTED_PERMISSIONS", permissions);
      },
    },
    permissions: {
      get() {
        return this.$store.getters["permissions/permissions"];
      },
      set(permissions) {
        this.$store.commit("permissions/SET_PERMISSIONS", permissions);
      },
    },
  },
  methods: {
    editAPermission(permission) {
      this.permissionToEdit = permission;
      this.$router.push({
        name: "editPermission",
        params: { permissionId: permission._id },
      });
    },
    deleteAPermission(permission) {
      this.itemToDelete = permission;
      this.removalAcceptance = true;
    },
    deletionConfirmed() {
      this.$store
        .dispatch("permissions/deletePermission", this.itemToDelete._id)
        .then((res) => {
          // this.$refs.tree.delNode(node, parent, index)
          this.$bvToast.toast(this.$t("toastification.deletionSucceed"), {
            // title: this.$t('toastification.success'),
            variant: "success",
            solid: true,
          });
          this.permissions = this.permissions.filter((p) => {
            return p._id !== res._id;
          });
          this.$emit("createFormattedPermission", this.permissions);
          this.createFormattedPermission(this.permissions);
          this.removalAcceptance = false;
        });
    },
    createFormattedPermission(res) {
      let list = _.cloneDeep(res);
      var map = {},
        node,
        roots = [],
        i;
      for (i = 0; i < list.length; i += 1) {
        map[list[i]._id] = i; // initialize the map
        list[i].children = []; // initialize the children
      }
      for (i = 0; i < list.length; i += 1) {
        node = list[i];
        if (node.parentId !== null) {
          list[map[node.parentId]].children.push(node);
        } else {
          roots.push(node);
        }
      }
      this.formattedPermissions = roots;
    },
    flatten(array) {
      var result = [];
      let parent = this;
      array.forEach(function (a) {
        result.push(a);
        if (Array.isArray(a.children)) {
          result = result.concat(parent.flatten(a.children));
        }
      });
      return result;
    },
    permissionChecked(event, selected) {
      this.checkedItemChildren = [];
      this.getAllChildren(selected);
      if (event) {
        !this.selectedUserPermissions.find((s) => {
          return s._id === selected._id;
        })
          ? this.selectedUserPermissions.push(selected)
          : "";
        this.checkedItemChildren.forEach((c) => {
          !this.selectedUserPermissions.find((s) => {
            return s._id === c._id;
          })
            ? this.selectedUserPermissions.push(c)
            : "";
          document.getElementById(`checkbox-${c.key}`).checked = true;
        });
      } else {
        this.selectedUserPermissions.find((s) => {
          return s._id === selected._id;
        })
          ? (this.selectedUserPermissions = this.selectedUserPermissions.filter((s) => {
              return s._id !== selected._id;
            }))
          : "";
        this.checkedItemChildren.forEach((c) => {
          this.selectedUserPermissions.find((s) => {
            return s._id === c._id;
          })
            ? (this.selectedUserPermissions = this.selectedUserPermissions.filter((s) => {
                return s._id !== c._id;
              }))
            : "";
          document.getElementById(`checkbox-${c.key}`).checked = false;
        });
      }
    },
    getAllChildren(node) {
      for (let i = 0; i < node.children.length; i++) {
        let child = node.children[i];
        this.getAllChildren(child);
        this.checkedItemChildren.push(child);
      }
    },
  },
};
</script>
<style scoped>
.row-style{
  display:flex;
  align-items:centre;
  justify-content:space-between ;
  width:100% ;
  /* border-bottom: 1px solid #e3dbdb61; */
  padding-bottom: 5px;
  margin-left: 14px;
  box-shadow: 0 0 4px -1px #8b959436;
  padding: 7px;}
</style>